<template>
	<div class="page-layout-box">
		<div class="page-layout-content">
			<!-- 左侧栏 -->
			<Sidebar class="Sidebar-layout" v-if="this.screenWidth > 1024"/>
			
			<!-- 中间内容 -->
			<!-- <Content class="Content-layout" /> -->
			
			<div class="Content-layout" id="ContentLayout">
				<keep-alive>
					<router-view ><Content class="Content-layout" /></router-view>
				</keep-alive>
				<Crumbs v-if="$route.name != 'home'"></Crumbs>
			</div>
			
			<!-- 右侧栏 -->
			<SearchUser class="RightSidebar-layout" v-if="this.screenWidth > 1024"/>
		</div>
	</div>
</template>

<script>
import Sidebar from './Sidebar.vue';
import Content from './Content.vue';
import SearchUser from './SearchUser.vue';
import Crumbs from './public/Crumbs.vue'

let that;
export default {
	name: 'PageLayout',
	components: {
		Sidebar,
		Content,
		SearchUser,
		Crumbs
	},
	
	data() {
		return {
  		
		}
	},
	
	
	// 路由进入可操作数据
	beforeRouteEnter(to, from, next) {
		that.post_scrollTop()
		next()
	},
	
	
	
	computed: {
		screenWidth() {
			return this.$sharedState.screenWidth;
		},
	},
	
	created () {
		that = this
	},
	
	methods: {
		post_scrollTop() {
			const state = pageStates[this.$route.name];
			if (state) {
				const scrollContainer = document.querySelector('.Content-layout');
				if (scrollContainer) {
					scrollContainer.scrollTop = state.scrollTop;
				}
			}
		},
	},
};
</script>

<style lang="less" scoped>
	* {
	  box-sizing: border-box;
	}
	.page-layout-content {
	  display: flex;
	  justify-content: space-between;
	  width: 100%;
	  max-width: 1280px;
	}
	/* 左右侧栏 */
	.Sidebar-layout,
	.RightSidebar-layout {
		position: -webkit-sticky; /* 针对 Safari 和部分旧版浏览器 */
		position: sticky; /* 吸顶效果 */
		top: 90px; /* 距离顶部的距离 */
		align-self: flex-start;
		width: 20%; /* 默认宽度 */
		max-height: calc(100vh - 90px); /* 防止溢出屏幕 */
		overflow-y: auto; /* 启用滚动条（如果需要） */
		border-radius: 8px;
		z-index: 0;
	}

	/* 中间内容区域 */
	.Content-layout {
		position: -webkit-sticky; /* 针对 Safari 和部分旧版浏览器 */
		position: sticky; /* 吸顶效果 */
		width: calc(100% - 20% - 25% - 20px);
		padding: 0px;
		overflow: auto; /* 中间内容可滚动 */
		border-radius: 8px;
		z-index: 2;
	}

	/* 响应式布局 */
	@media screen and (min-width: 1320px) {
		/* .Sidebar-layout {
			width: 28%;
			max-width: 360px;
		}
		.Content-layout {
			width: calc(100% - 28% - 10px);
			max-width: calc(100% - 360px - 0px);
		} */
	 .Sidebar-layout {
		 width: 20%;
		 max-width: 260px;
	  }
	  .Content-layout {
		 width: calc(100% - 20% - 25% - 20px);
		 max-width: calc(100% - 260px - 330px - 0px);
	  }
	  .RightSidebar-layout {
		 width: 25%;
		 max-width: 330px;
	  }
	}

	@media screen and (min-width: 1024px) {
		.page-layout-box {
			padding: 10px 10px;
			display: flex;
			justify-content: center;
			width: 100%;
			background-color: #f6f6f6;
		}
	}
	@media screen and (max-width: 1024px) {
		.page-layout-box {
		   padding: 0px 10px 10px 10px;
		}
		.page-layout-box {
			margin-top: 10px;
			padding-bottom: 10px;
			display: flex;
			justify-content: center;
			width: 100%;
			background-color: #f6f6f6;
			/* background-color: #ffffff; */
		}
	}
	@media screen and (max-width: 1320px) and (min-width: 1025px) {
		/* .Sidebar-layout {
			width: 28%;
			max-width: 360px;
		}
		.Content-layout {
			width: calc(100% - 28% - 10px);
			max-width: calc(100% - 28% - 10px);
		} */
		.Sidebar-layout {
			width: 20%;
		}
		.Content-layout {
			width: calc(100% - calc(20% + 25% + 20px));
		}
		.RightSidebar-layout {
			width: 25%;
		}
		.page-layout-box{
			padding: 10px 10px;
		}
	}
	@media screen and (max-width: 1024px) {
		.Sidebar-layout {
			width: 0px;
		}
		.Content-layout {
			width: 100%;
		}
		.RightSidebar-layout {
			width: 0px;
		}
	}
	/* @media screen and (max-width: 1024px) and (min-width: 800px) {
	  .Sidebar-layout {
		 width: 20%;
		 width: 160px;
	  }
	  .Content-layout {
		 width: calc(100% - calc(160px + 200px + 20px));
		 background-color: #fff;
	  }
	  .RightSidebar-layout {
		 width: 200px;
	  }
	} */
</style>
